import { useGetClientUserPaperwork as useSeedlingGetClientUserPaperwork } from '@grow-therapy-team/seedling-components';

export function useGetOutstandingMeasures(clientUserShortId: string, providerShortId: string) {
  const { data, loading, error } = useSeedlingGetClientUserPaperwork(clientUserShortId, providerShortId, {
    // Specifically want the ones for this client + provider relationship
    skip: !providerShortId || !clientUserShortId,
  });

  return {
    outstandingMeasures: data?.outstandingMeasures || [],
    loading,
    error,
  };
}
